/**
 * Un precio que se lee mientras se escribe.
 *
 * ERA UN `input type="number"` Y TRAÍA DOS PROBLEMAS, los dos vistos en la
 * obra por Johan: «no hay separadores de 1000, se está quedando un 0 adelante».
 *
 *  · SIN SEPARADORES, 1500000 y 150000 se distinguen contando ceros con el
 *    dedo en la pantalla. Es un millón y medio contra ciento cincuenta mil, en
 *    un campo que decide lo que se le cobra al cliente.
 *  · EL CERO DELANTE es cosa del navegador: el campo arranca en 0, se teclea
 *    encima y queda «01500000». React no lo corrige porque para un campo
 *    numérico «01500000» y 1500000 valen lo mismo, así que deja lo que hay
 *    escrito. El valor guardado estaba bien; lo que mentía era la pantalla, y
 *    es la pantalla lo que la persona revisa antes de generar.
 *
 * Así que el campo es de texto y las cifras se dibujan aquí: solo dígitos
 * —punto y coma se caen, y el teclado del teléfono sigue saliendo numérico por
 * `inputMode`— y los miles separados a la colombiana. El estado de fuera sigue
 * siendo un número: esto no cambia lo que se guarda, cambia lo que se ve.
 */

const AGRUPADOR = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 })

/** De lo tecleado al número: se queda con los dígitos y nada más. */
export function soloDigitos(texto: string): number {
  const limpio = texto.replace(/\D/g, '')
  return limpio === '' ? 0 : Number(limpio)
}

type Props = {
  valor: number
  onCambio: (valor: number) => void
  className?: string
  title?: string
  'aria-label': string
}

export function CampoDePesos({ valor, onCambio, className, title, ...resto }: Props) {
  return (
    <input
      className={className}
      type="text"
      inputMode="numeric"
      /* En cero se deja vacío: un 0 escrito invita a teclear detrás, que es
         justo como nacía el «01500000». */
      value={valor === 0 ? '' : AGRUPADOR.format(valor)}
      placeholder="0"
      /* Mismo gesto que la cantidad: al tocarlo se selecciona lo que hay, para
         escribir encima sin pelear con el cursor en el teléfono. */
      onFocus={(e) => e.currentTarget.select()}
      onChange={(e) => onCambio(soloDigitos(e.target.value))}
      title={title}
      {...resto}
    />
  )
}
